// @flow 
import * as React from 'react';
import './Loader.css'
export const Loader = () => {
    return (
        <div class="loading">foregroung loader&#8230;</div>
    );
};